import {inject, Injectable} from '@angular/core';
import {DataUpdateService} from "./data-update.service";
import {AppUpdateService} from "./app-update.service";
import {isNative} from "../utils";
import {App} from "@capacitor/app";
import {SplashScreen} from "@capacitor/splash-screen";

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  private readonly dataUpdateService = inject(DataUpdateService);
  private readonly appUpdateService = inject(AppUpdateService);

  public initialize() {
    this.update();
    App.addListener('resume', () => {
      this.update();
    });
  }

  private async update() {
    await this.appUpdateService.checkForUpdates();
    await this.dataUpdateService.updateData();

    if(isNative) {
      await SplashScreen.hide();
    }
  }
}
